import React, {Fragment} from "react";
import { withStyles, withTheme } from "@material-ui/core";
import styles from "../styles";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { postData } from "../../../../api/componentAPIs";

const displayStyles = theme => ({
    appearanceContainer:{
        display:"inline-flex",
        padding: "8px 0",
        boxSizing: "border-box",
        maxHeight: 180
    },
    appearanceText:{
        width: 250,
        height: 120,
        lineHeight: "120px",
        color: theme.HeaderSelectedText,
        fontSize:14,
        fontWeight: 600
    },
    appearanceOption:{
        width: 160,
        padding: 25,
        cursor: "pointer"
    },
    appearanceImage:{
        width:85,
        height:85,
        // backgroundColor: theme.AppBGColor,
    },
    appearanceActive:{
        border:`2px solid ${theme.HeaderSelectedText}`,
        boxSizing: "border-box",
        '&+$appearanceName':{
            fontWeight: 600
        }
    },
    appearanceImageLight:{
        background: 'url("../../../../images/LightTheme.svg")'
    },
    appearanceImageDark:{
        background: 'url("../../../../images/DarkTheme.svg")'
    },
    appearanceName:{
        paddingTop:24,
        color: theme.TextColor,
        fontSize:14
    }

})
const Display = props => {
    const { classes } = props;
    const { themeName } = props.theme;
    function toggleTheme(theme){
        props.userData.toggleTheme(theme);
        postData("SetUserPreferences", {
            theme: theme
        }).then(response=>{
            if(response && Math.trunc(response.status/100) === 2){
                console.log("Saved theme changes");
            }
        }, error=>{
            console.log("Failed to save theme changes", error)
        })
    }
    return (
        <Fragment>
        <header className={classes.moduleHeader}  data-automationid="display-title"> Display Preferences </header>
        <div className={classes.moduleContainer}>
            <div className={classes.appearanceContainer}>
                    <div className={classes.appearanceText}> Appearance</div>
                    <div className={classes.appearanceOption} onClick={e=>{toggleTheme("light")}}>
                        <div className={`${classes.appearanceImage} ${classes.appearanceImageLight} ${themeName === "light" ? classes.appearanceActive : ""}`}/>
                        <div className={classes.appearanceName}> Light theme </div>
                    </div>
                    <div className={classes.appearanceOption} onClick={e=>toggleTheme("dark")}>
                        <div className={`${classes.appearanceImage} ${classes.appearanceImageDark} ${themeName === "dark" ? classes.appearanceActive : ""}`}/>
                        <div className={classes.appearanceName}> Dark theme</div>
                    </div>
            </div>
        </div>
        </Fragment>
    )
}

export default compose(withStyles((theme) => ({
    ...styles(theme),
    ...displayStyles(theme),
})), withTheme(), withUserProfile)(Display)